export default __webpack_public_path__ + "static/media/pexels-cottonbro-6686442.d45ae569.jpg";